/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface AgreementUsageStats
 */
export interface AgreementUsageStats {
  /**
   *
   * @type {string}
   * @memberof AgreementUsageStats
   */
  customerSpecificPricingAgreementId: string;
  /**
   *
   * @type {number}
   * @memberof AgreementUsageStats
   */
  quoteCount: number;
  /**
   *
   * @type {number}
   * @memberof AgreementUsageStats
   */
  shipmentCount: number;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof AgreementUsageStats
   */
  firstQuoteAt?: OffsetDateTime | null;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof AgreementUsageStats
   */
  lastQuoteAt?: OffsetDateTime | null;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof AgreementUsageStats
   */
  firstShipmentBookedAt?: OffsetDateTime | null;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof AgreementUsageStats
   */
  lastShipmentBookedAt?: OffsetDateTime | null;
}

/**
 * Check if a given object implements the AgreementUsageStats interface.
 */
export function instanceOfAgreementUsageStats(
  value: object,
): value is AgreementUsageStats {
  if (
    !("customerSpecificPricingAgreementId" in value) ||
    value["customerSpecificPricingAgreementId"] === undefined
  )
    return false;
  if (!("quoteCount" in value) || value["quoteCount"] === undefined)
    return false;
  if (!("shipmentCount" in value) || value["shipmentCount"] === undefined)
    return false;
  return true;
}

export function AgreementUsageStatsFromJSON(json: any): AgreementUsageStats {
  return AgreementUsageStatsFromJSONTyped(json, false);
}

export function AgreementUsageStatsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AgreementUsageStats {
  if (json == null) {
    return json;
  }
  return {
    customerSpecificPricingAgreementId:
      json["customerSpecificPricingAgreementId"],
    quoteCount: json["quoteCount"],
    shipmentCount: json["shipmentCount"],
    firstQuoteAt:
      json["firstQuoteAt"] == null ? undefined : json["firstQuoteAt"],
    lastQuoteAt: json["lastQuoteAt"] == null ? undefined : json["lastQuoteAt"],
    firstShipmentBookedAt:
      json["firstShipmentBookedAt"] == null
        ? undefined
        : json["firstShipmentBookedAt"],
    lastShipmentBookedAt:
      json["lastShipmentBookedAt"] == null
        ? undefined
        : json["lastShipmentBookedAt"],
  };
}

export function AgreementUsageStatsToJSON(json: any): AgreementUsageStats {
  return AgreementUsageStatsToJSONTyped(json, false);
}

export function AgreementUsageStatsToJSONTyped(
  value?: AgreementUsageStats | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    customerSpecificPricingAgreementId:
      value["customerSpecificPricingAgreementId"],
    quoteCount: value["quoteCount"],
    shipmentCount: value["shipmentCount"],
    firstQuoteAt: value["firstQuoteAt"],
    lastQuoteAt: value["lastQuoteAt"],
    firstShipmentBookedAt: value["firstShipmentBookedAt"],
    lastShipmentBookedAt: value["lastShipmentBookedAt"],
  };
}
